import { createContext, useContext } from "react";

interface DateContextType {
  selectedDate: Date | null;
  setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>;
}



export const DateContext = createContext<DateContextType | null>(null);

export function useDateContext() {
  const ctx = useContext(DateContext);
  if (!ctx) throw new Error("useDateContext must be used inside UserProvider");
  return ctx;
}